import BaseRepository from "@/services/resources/repository";
import queryByKeys from "@/services/resources/mixins/query-by-keys";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(queryByKeys);
    }

    record(id) {
        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .include('testimonial-testimonial-categories')
                    .find(id)
            )
        );
    }

    withTestimonialCategories() {
        return this.transformer.many(
            this.try(
                this.baseQuery()
                    .include('testimonial-testimonial-categories.testimonial-categories')
                    .get()
            )
        );
    }

    search(keywords) {
        return this.transformer.many(
            this.try(
                this.baseSearchQuery(
                    ['testimonial-modules.modules.modules'],
                    ['title', 'summary', 'testimonial-modules.modules.modules.attributes']
                    , keywords
                ).get()
            )
        ).then(collection => {
            return collection.map(record => {
                return {
                    type: 'testimonials',
                    id: record.id,
                    text: record.title,
                    resource: record
                }
            })
        })
    }
}

export default Repository;
